import { ComponentRef, Injectable, OnDestroy, Renderer2, RendererFactory2, ViewContainerRef } from "@angular/core";
import * as mapboxgl from "mapbox-gl";
import { environment } from "../../../../../../environments/environment";
import * as Sentry from '@sentry/angular';
import { MapHelperService } from "src/services/map-helper.service";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { PanelDetailLocationsService } from "./Panel-Detail-Locations.service";
import { LocationsService } from "./Locations.service";
import { PanelLocationsService } from "./Panel-Locations.service";
import { GeoClustersFrecuencyPlacesService } from "./GeoClustersFrecuencyPlaces.service";
import { LocationRelatedService } from "./LocationRelated.service";
import { SwalNotificationService } from "../../../../shared/services/SwalNotification.service";
import { LocationCategoryDTO } from "../models/LocationCategoryDTO";
import { BehaviorSubject, first, Subscription } from "rxjs";
import { EstatusJSON } from "../../../../shared/models/EstatusJSON";
import { LayerDTO } from "../models/LayerDTO";
import { IconLoadMapService } from "src/services/maps/features/IconLoad-Map.service";
import { LocalStorageService } from "../../../../shared/services/LocalStorage.service";
import { SessionService } from "src/app/features/shared/services/Session.service";
import { MAP_MODULE_NAMES } from "src/models/common/EnumMapas";
import { EncriptionService } from "src/app/features/shared/services/Encription.service";
import { CarouselComponent } from "src/app/features/ui/molecules/carousel/carousel.component";
import { MapRestrictionsService } from "src/app/features/pages/maps/services/MapRestrictions.service";
import { RouteSheetService } from "../../../ui/organisms/route-sheet/service/RouteSheet.service";
import { RouteSheetLocationDTO } from "../../../ui/organisms/route-sheet/models/RouteSheetLocationDTO";
import { StringUtilities } from "src/app/features/shared/helpers/utilities/StringUtilities";
@Injectable({
  providedIn: "root",
})
export class LocationsMapService{

  //variables para crear un componente dinamicamente (estas son para el carrusel del popup)
  private carouselViewContainerRef: ViewContainerRef;
  private renderer: Renderer2;

  //variables para iconos
  generalMapIconSize: number = 0.1011;

  
  PinSelected: any;

  public streetViewUrl: SafeResourceUrl;
  public isStreetViewUrlReady: boolean = false;

  
  public locationsubscription: Subscription;
  // Pitch: number;
  constructor(
    private sessionService: SessionService,

    private mapHelperService: MapHelperService,
    private panelDetailLocationsService: PanelDetailLocationsService,
    private locationsService: LocationsService,
    private panelLocationsService: PanelLocationsService,
    private rendererFactory: RendererFactory2,
    private geoClustersFrecuencyCatalogService: GeoClustersFrecuencyPlacesService,
    private locationRelatedCatalogService: LocationRelatedService,
    private routeSheetService: RouteSheetService,
    private notifyService: SwalNotificationService,
    private iconLoadMapService: IconLoadMapService,
    private localStorageService: LocalStorageService,  
    private encriptionService:  EncriptionService,
    private mapRestrictionsService: MapRestrictionsService,
  ) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  public setCarouselViewContainerRef(vcr: ViewContainerRef) {
    this.carouselViewContainerRef = vcr;
  }


  public LoadMapLocations() {
    // const current = this.sessionService.loadedMapComponents.value;
    // this.sessionService.loadedMapComponents.next([...current, MAP_MODULE_NAMES.Locations]);
    this.addViewAsLoadedToStorage();

    // this.mapHelperService._map.on("load", () => {

    this.initializeMapLocations();

    var hoveredMarker = null;
    var hoveredMarkerFeature = null;
    var popup = new mapboxgl.Popup({});

      const layerMouseOver = (e) => {
        // Obtener ID del marcador
        const marker = e.features[0].properties;

        // Almacenar referencia al marcador
        hoveredMarker = marker;
        hoveredMarkerFeature = e.features[0];

        var categoryIcon = hoveredMarker.LocationCategoryActiveIcon as string;

        // categoryIcon = categoryIcon.replace(".png", "A.png");

        // Cambiar icono del marcador (el primer case es para encontrar el feature y el segundo para cambiar el icono), el segundo es del filtro
        this.mapHelperService._map.setLayoutProperty(
          "layer-locationsGeneral",
          "icon-image",
          [
            "case",
            ["==", ["get", "_Id"], marker._Id],
            categoryIcon,
            ["get", "LocationCategoryIcon"],
          ]
        );
        this.mapHelperService._map.setLayoutProperty(
          "filter-layer-locationsGeneral",
          "icon-image",
          [
            "case",
            ["==", ["get", "_Id"], marker._Id],
            categoryIcon,
            ["get", "LocationCategoryIcon"],
          ]
        );

        // cambia el color del nombre
        this.mapHelperService._map.setPaintProperty("layer-pinText", "text-color", [
          "case",
          ["==", ["get", "_Id"], marker._Id],
          "#0F010F",
          "#530aa8",
        ]);
        this.mapHelperService._map.setPaintProperty(
          "filter-layer-pinText",
          "text-color",
          ["case", ["==", ["get", "_Id"], marker._Id], "#0F010F", "#530aa8"]
        );

        // Mostrar popup y lo guarda en la cariable para despues cerrarlo
        // popup = new mapboxgl.Popup({ offset: [0, -15] })
        //     .setLngLat(coordinates)
        //     .setHTML(`<h3>${nombre}</h3>`)
        //     .addTo(this.mapHelperService._map);
      };

      const layerMouseLeave = () => {
        // Restaurar icono y texto del punto solo si hay un punto bajo el mouse
        if (hoveredMarker) {
          if(!environment.production) console.log("hoveredMarkerId", hoveredMarker);

          // Cambiar icono del marcador
          this.mapHelperService._map.setLayoutProperty(
            "layer-locationsGeneral",
            "icon-image",
            ["get", "LocationCategoryIcon"]
          );
          this.mapHelperService._map.setPaintProperty(
            "layer-pinText",
            "text-color",
            "#530aa8"
          );

          this.mapHelperService._map.setLayoutProperty(
            "filter-layer-locationsGeneral",
            "icon-image",
            ["get", "LocationCategoryIcon"]
          );
          this.mapHelperService._map.setPaintProperty(
            "filter-layer-pinText",
            "text-color",
            "#530aa8"
          );
          hoveredMarker = null;
        }

        // Cerrar popup si está abierto
        if (popup) {
          popup.remove();
          popup = null;
        }
      };

      let currentPopup: mapboxgl.Popup = null;
      let popupTimeoutId: any = null;
      let isMouseNearPopup = false;

      const categoryPopUpMouseOver = (e) => {
        // por si hay un popup anterior a medio cerrar
        if (popupTimeoutId) {
          clearTimeout(popupTimeoutId);
          popupTimeoutId = null;
        }
        if (currentPopup) {
          currentPopup.remove();
          currentPopup = null;
        }

        // Obtener ID del marcador
        const marker = e.features[0];
        var layerName = "";
        if (
          e.features &&
          e.features[0] &&
          e.features[0].layer &&
          e.features[0].layer.id
        )
          layerName = e.features[0].layer.id;

        // Almacenar referencia al marcador
        hoveredMarker = marker;
        hoveredMarkerFeature = e.features[0];

        var categoryIcon = hoveredMarker.properties.Icon as string;
        var categoryActiveIcon = categoryIcon.replace(".png", "A.png");

        // Cambiar icono del marcador (el primer case es para encontrar el feature y el segundo para cambiar el icono), el segundo es del filtro
        this.mapHelperService._map.setLayoutProperty(layerName, "icon-image", [
          "case",
          ["==", ["get", "IdentifierChild"], marker.properties.IdentifierChild],
          categoryActiveIcon || categoryIcon,
          ["get", "Icon"],
        ]);

        const obj: any = e.features[0].properties;
        if(!environment.production) console.log("Objeto over", obj);

        const identifier: string = e.features[0].properties.IdentifierChild;
        const idLocationCategory: number =
          e.features[0].properties.IdLocationCategory;
        const description: string = e.features[0].properties.Description;
        const date: string = e.features[0].properties.CreatedIn;
        const name: string = e.features[0].properties.Title;
        const img: string = e.features[0].properties.Icon;
        const images = JSON.parse(this.localStorageService.getUrlMapList());
        const imgUrl = images.find((x) => x.name === img);

        // Crea el componente dinámicamente y pone estilo
        const componentRef: ComponentRef<CarouselComponent> = this.carouselViewContainerRef.createComponent(CarouselComponent);
        componentRef.instance.identifier = identifier;
        componentRef.instance.idLocationCategory = idLocationCategory;
        const carouselElement = componentRef.location.nativeElement;
        this.renderer.setStyle(carouselElement, "display", "flex");
        this.renderer.setStyle(carouselElement, "height", "100%");
        this.renderer.setStyle(carouselElement, "max-height", "120px");

        // Contenedor del popup
        const popupContainer = document.createElement("div");
        popupContainer.className = "popup-container";
        popupContainer.style.position = "relative";
        popupContainer.style.height = "auto";
        popupContainer.style.display = "flex";
        popupContainer.style.flexDirection = "column";
        popupContainer.style.justifyContent = "center";

        // para crear el carousel
        const carouselContainer = document.createElement("div");
        carouselContainer.style.width = "100%";
        // carouselContainer.style.minHeight = "15px";
        carouselContainer.style.maxHeight = "115px";
        carouselContainer.style.height = "auto";
        carouselContainer.style.overflow = "hidden";
        carouselContainer.style.position = "relative";
        // carouselContainer.style.marginTop = '8px';

        carouselContainer.appendChild(carouselElement);
        popupContainer.appendChild(carouselContainer);

        // Ttítulo con descripcion y clic
        const titleElement = document.createElement("h3");
        titleElement.innerText = description;
        titleElement.style.margin = "0 0 3px 10px";
        titleElement.style.color = "#3f51b5";
        titleElement.style.overflowX = "auto";
        titleElement.style.overflowY = "hidden";
        titleElement.style.maxHeight = "40px";
        titleElement.style.width = "90%";
        titleElement.style.whiteSpace = "nowrap";
        titleElement.addEventListener("mouseover", () => {
          titleElement.style.color = "#31ab45";
          titleElement.style.textDecoration = "underline";
          titleElement.style.cursor = "pointer";
        });
        titleElement.addEventListener("mouseleave", () => {
          titleElement.style.color = "#3f51b5";
          titleElement.style.textDecoration = "none";
        });
        var routeSheetLocationDTO = {
          identifierChild: identifier,
          idLocationCategory: idLocationCategory
        } as RouteSheetLocationDTO;
        titleElement.addEventListener("click", () => {
          this.locationRelatedCatalogService.openRelatedDetailsPopup(
            identifier
          );
          this.routeSheetService.openRouteSheetDetailsPopup(
            routeSheetLocationDTO,
            "",
            ""
          );
          this.mapHelperService.clearPopupEvents("images-popup-routeSheet");
        });
        popupContainer.appendChild(titleElement);

        // descripción flex padre
        const descriptionElement = document.createElement("div");
        descriptionElement.style.height = "50px";
        descriptionElement.style.margin = "0";
        descriptionElement.style.display = "flex";
        descriptionElement.style.flexDirection = "row";

        //imagen a la izquierda
        const descriptionImageElement = document.createElement("img");
        descriptionImageElement.style.width = "25%";
        descriptionImageElement.style.objectFit = "contain";
        descriptionImageElement.style.marginRight = "8px";
        // descriptionImageElement.style.borderRadius = '4px';
        descriptionImageElement.src = imgUrl?.url || "";
        descriptionElement.appendChild(descriptionImageElement);

        //flex con datos a la derecha
        const descriptionDataElement = document.createElement("div");
        descriptionDataElement.style.margin = "0";
        descriptionDataElement.style.display = "flex";
        descriptionDataElement.style.flexDirection = "column";
        descriptionElement.appendChild(descriptionDataElement);

        //titulo en los datos de la derecha
        const descriptionDataTitleElement = document.createElement("p");
        descriptionDataTitleElement.style.maxHeight = "25px";
        descriptionDataTitleElement.style.overflowX = "auto";
        descriptionDataTitleElement.style.overflowY = "hidden";
        descriptionDataTitleElement.style.margin = "0";
        descriptionDataTitleElement.style.whiteSpace = "nowrap";
        descriptionDataTitleElement.style.fontWeight = "bold";
        descriptionDataTitleElement.innerText = identifier;
        descriptionDataElement.appendChild(descriptionDataTitleElement);

        //fecha en los datos de la derecha
        const descriptionDataDateElement = document.createElement("p");
        descriptionDataDateElement.style.maxHeight = "25px";
        descriptionDataDateElement.style.overflowX = "hidden";
        descriptionDataDateElement.style.overflowY = "hidden";
        descriptionDataDateElement.style.margin = "0";
        descriptionDataDateElement.style.whiteSpace = "nowrap";
        descriptionDataDateElement.innerText = date;
        descriptionDataElement.appendChild(descriptionDataDateElement);

        //nombre en los datos de la derecha
        const descriptionDataNameElement = document.createElement("p");
        descriptionDataNameElement.style.maxHeight = "25px";
        descriptionDataNameElement.style.overflowX = "hidden";
        descriptionDataNameElement.style.overflowY = "hidden";
        descriptionDataNameElement.style.margin = "0";
        descriptionDataNameElement.style.whiteSpace = "nowrap";
        descriptionDataNameElement.style.fontWeight = "bold";
        descriptionDataNameElement.innerText = name;
        descriptionDataElement.appendChild(descriptionDataNameElement);

        popupContainer.appendChild(descriptionElement);

        // Crear y mostrar el popup
        currentPopup = new mapboxgl.Popup({
          closeButton: false,
          className: "images-popup-routeSheet",
          offset: [0, -25],
        })
          .setLngLat(e.lngLat)
          .setDOMContent(popupContainer)
          .addTo(this.mapHelperService._map);

        // agrego que acepte el mouse sobre el popup para que no se cierre al estar encima y un tieout para que no se cierre sin querer
        const popupElement = currentPopup.getElement();
        if (popupElement) {
          popupElement.addEventListener("mouseenter", () => {
            isMouseNearPopup = true;
            if (popupTimeoutId) {
              clearTimeout(popupTimeoutId);
              popupTimeoutId = null;
            }
          });

          popupElement.addEventListener("mouseleave", () => {
            isMouseNearPopup = false;
            popupTimeoutId = setTimeout(() => {
              categoryPopUpMouseLeave();
            }, 100);
          });
        }
      };

      const categoryPopUpMouseLeave = () => {
        if (isMouseNearPopup) {
          return;
        }

        popupTimeoutId = setTimeout(() => {
          if (hoveredMarker && !isMouseNearPopup) {
            if(!environment.production) console.log("hoveredMarkerId", hoveredMarker);
            var layerName = hoveredMarker.layer.id;
            // Cambiar icono del marcador
            this.mapHelperService._map.setLayoutProperty(layerName, "icon-image", [
              "get",
              "Icon",
            ]);
            this.mapHelperService._map.setPaintProperty(
              layerName + "-PinText",
              "text-color",
              "#530aa8"
            );

            hoveredMarker = null;
          }
          if (currentPopup) {
            currentPopup.remove();
            currentPopup = null;
          }
        }, 100);
      };

      const layerMouseClick = (e) => {
        if (this.mapHelperService.isPointPickingActive) {
          return;
        }
        var obj: any = e.features[0].properties;
        if(!environment.production) console.log("Objeto Clicked", obj);
        var $identifier: string = obj._Id;
        var $locationCategory: number = obj.IdLocationCategory;

        // abre el detalle de carros desde el clic y comienza a cargar
        this.panelDetailLocationsService.setCategorySelected($locationCategory);
        setTimeout(() => {
          // this.panelDetailLocationsService.setVisibilityPopup(true);
          this.panelDetailLocationsService.setLoading(true);
        }, 500);
        this.onFocusPin($identifier);
      };

      const relatedCategoryMouseClick = (e) => {
        if (this.mapHelperService.isPointPickingActive) {
          return;
        }
        this.locationRelatedCatalogService.openRelatedDetailsPopup(
          e.features[0].properties.IdentifierChild
        );
      };

      // const routeSheetMouseClick = (e) => {
      //   var routeSheetLocationDTO = {
      //     identifierChild: e.features[0].properties.IdentifierChild,
      //   } as RouteSheetLocationDTO;

      //   this.routeSheetService.openRouteSheetDetailsPopup(
      //     routeSheetLocationDTO,
      //     "",
      //     ""
      //   );
      // };

      // Evento mouseenter
      this.mapHelperService.AddLayerEvent("mouseenter", "layer-locationsGeneral", layerMouseOver);
      this.mapHelperService.AddLayerEvent("mouseenter", "filter-layer-locationsGeneral", layerMouseOver);
      this.mapHelperService.AddLayerEvent("mouseenter", "layer-pinText", layerMouseOver);
      this.mapHelperService.AddLayerEvent("mouseenter", "filter-layer-pinText", layerMouseOver);
      this.mapHelperService.AddLayerEvent("mouseenter", "layer-LocationRelated", categoryPopUpMouseOver);
      // this.mapHelperService.AddLayerEvent("mouseenter", "layer-RouteSheetLocations-Services", categoryPopUpMouseOver);
      // this.mapHelperService.AddLayerEvent("mouseenter", "layer-RouteSheetLocations-Unit", categoryPopUpMouseOver);

      // Evento mouseleave
      this.mapHelperService.AddLayerEvent("mouseleave", "layer-locationsGeneral", layerMouseLeave);
      this.mapHelperService.AddLayerEvent("mouseleave", "filter-layer-locationsGeneral", layerMouseLeave);
      this.mapHelperService.AddLayerEvent("mouseleave", "layer-pinText", layerMouseLeave);
      this.mapHelperService.AddLayerEvent("mouseleave", "filterlayer-pinText", layerMouseLeave);
      this.mapHelperService.AddLayerEvent("mouseleave", "layer-LocationRelated", categoryPopUpMouseLeave);
      // this.mapHelperService.AddLayerEvent("mouseleave", "layer-RouteSheetLocations-Services", categoryPopUpMouseLeave);
      // this.mapHelperService.AddLayerEvent("mouseleave", "layer-RouteSheetLocations-Unit", categoryPopUpMouseLeave);

      // Evento click
      this.mapHelperService.AddLayerEvent("click", "layer-locationsGeneral", layerMouseClick);
      this.mapHelperService.AddLayerEvent("click", "filter-layer-locationsGeneral", layerMouseClick);
      this.mapHelperService.AddLayerEvent("click", "layer-LocationRelated", relatedCategoryMouseClick);
      // this.mapHelperService.AddLayerEvent("click", "layer-RouteSheetLocations-Services", routeSheetMouseClick);
      // this.mapHelperService.AddLayerEvent("click", "layer-RouteSheetLocations-Unit", routeSheetMouseClick);

      
    // });

  }

  initializeMapLocations() {
      var locationCategories = JSON.parse(this.localStorageService.getListaCategorias() || "[]") as LocationCategoryDTO[];
      // this.mapHelperService.AddMapboxPlaces();
      this.mapHelperService.AddSourceEmptyGeoJson("routeLocationRelatedSource", "Ubicaciones relacionadas con ruta", '');
      this.mapHelperService.AddSourceEmptyGeoJson("locationRelatedSource", "Ubicaciones relacionadas", ''); 

      this.mapHelperService.AddSourceEmptyGeoJson("routeToRouteSheetPointSource", "Ruta al destino", '');
      // this.mapHelperService.AddSourceEmptyGeoJson("routeSheetLocationsSource-Services", "Puntos de ruta - Servicios");
      // this.mapHelperService.AddSourceEmptyGeoJson("routeSheetLocationsSource-Unit", "Puntos de ruta - Unidad");

      this.mapHelperService.AddSourceClusteredEmptyGeoJson("pointsSource", "Activos de gps", 'icon_control_activos.png');
      this.mapHelperService.AddSourceClusteredEmptyGeoJson("filterPointsSource", "Activos filtrados", 'icon_control_activos.png');

      this.mapHelperService.AddSourceEmptyGeoJson("locationDetailsRoute", "Ruta de detalles de activo", 'annotation-line-bold.png');

      // considerar (es lo de la animacion de asignaicon de servicios  aingenieros) ----------------------------------------
      this.mapHelperService.AddSourceEmptyGeoJson("serviceAssignmentRegionsSource", "Regiones de asignación de servicio", 'annotation-polygon.png');
      this.mapHelperService.AddSourceEmptyGeoJson("serviceAssignmentZonesSource", "Zonas de asignación de servicio", 'annotation-polygon.png');
      this.mapHelperService.AddSourceEmptyGeoJson("serviceAssignmentClustersSource", "Clusters de asignación de servicio", 'service.png');
      // this.AddSourceClusteredEmptyGeoJson("serviceAssignmentClustersSource");
      this.mapHelperService.AddSourceEmptyGeoJson("serviceAssignmentFinishedEngineerSource", "Ingenieros de asignación de servicio finalizados", 'engineer.png');
      this.mapHelperService.AddSourceEmptyGeoJson("serviceAssignmentFinishedServiceSource", "Servicios de asignación de servicio finalizados", 'service.png');
      // considerar --------------------------------------------

      this.mapHelperService.AddBaseMapSatellite();
      this.mapHelperService.AddLayerCluster("filter-clusters", "filterPointsSource", "Clusters de filtro");
      this.mapHelperService.AddClusterZoomEvent("filter-clusters", "filterPointsSource");
      this.mapHelperService.AddLayerClusterCount("filter-cluster-count", "filterPointsSource", "Conteo de clusters de filtro");
      this.mapHelperService.AddLayerText("filter-layer-pinText", "filterPointsSource", "_Id", "Etiqueta de filtro", -2);

      this.mapHelperService.AddLayerCluster("clusters", "pointsSource", "Clusters de puntos");
      this.mapHelperService.AddClusterZoomEvent("clusters", "pointsSource");
      this.mapHelperService.AddLayerClusterCount("cluster-count", "pointsSource", "Conteo de clusters");
      this.mapHelperService.AddLayerText("layer-pinText", "pointsSource", "_Id", "Etiqueta de puntos", -2.2);

      this.mapHelperService.ShowHideLayer("satellite-layer");
      this.mapHelperService.ShowHideLayer("satellite-layer");

      this.mapHelperService.AddLayerLocationsGeneral("filter-layer-locationsGeneral", "filterPointsSource", 'LocationCategoryIcon', "Ubicaciones filtradas", this.generalMapIconSize);
      this.mapHelperService.AddLayerLocationsGeneral("layer-locationsGeneral", "pointsSource", 'LocationCategoryIcon', "Ubicaciones generales", this.generalMapIconSize);

      if(!environment.production) console.log("listaCategorias categories", locationCategories);
      locationCategories.forEach((category) => {
        const singularLabel = StringUtilities.ToSingular(category.shortName) + " Seleccionado";
        this.mapHelperService.AddSourceEmptyGeoJson("location"+category.name+"ActiveSource", singularLabel, category.activeIcon );
        this.mapHelperService.AddLayerLocationActive("layer-location"+category.name+"Active", "location"+category.name+"ActiveSource", category.activeIcon, singularLabel, this.generalMapIconSize);
      });
      this.mapHelperService.AddLayerLine( "layer-locationDetailsRoute", "locationDetailsRoute", "Ruta dinámica del detalle", "#354F84", 5);
  
      // para ver su click, buscar la funcion CategoryPopUpMouseOver en el onloadMapLocations --- todo: revisar el icono
      this.mapHelperService.AddLayerText( "layer-LocationRelated-PinText", "locationRelatedSource", "IdentifierChild", "Etiqueta de ubicación relacionada", -2 );
      this.mapHelperService.AddLayerLocationsGeneral("layer-LocationRelated", "locationRelatedSource", 'Icon', "Ubicaciones relacionadas", this.generalMapIconSize, true);
      this.mapHelperService.AddLayerLine( "layer-LocationRelatedRoute", "routeLocationRelatedSource", "Ruta a ubicación relacionada", "#352F84", 5 );

      //su funcion de click es igual a location related, pero es exclusivo de route sheet
      // this.mapHelperService.AddDirectionLine( "layer-RouteSheetRoute-Services", "routeSheetRouteSource-Services", "Ruta de servicios" );
      // this.mapHelperService.AddDirectionLine( "layer-RouteSheetRoute-Unit", "routeSheetRouteSource-Unit", "Ruta de unidades" );
      this.mapHelperService.AddLayerLine( "layer-RouteSheetRouteToPoint", "routeToRouteSheetPointSource", "Ruta punto actual al destino", "#354F84", 5);
      // para route sheet servicios
      // this.mapHelperService.AddLayerText( "layer-RouteSheetLocations-Services-PinText", "routeSheetLocationsSource-Services", "IdentifierChild", "Etiqueta de servicios", -2);
      // this.mapHelperService.AddLayerLocationsGeneral("layer-RouteSheetLocations-Services", "routeSheetLocationsSource-Services", "Icon", "Ubicaciones de servicios", this.generalMapIconSize, true);
      // // para routesheet unidades
      // this.mapHelperService.AddLayerText( "layer-RouteSheetLocations-Unit-PinText", "routeSheetLocationsSource-Unit", "IdentifierChild", "Etiqueta de unidades", -2);
      // this.mapHelperService.AddLayerLocationsGeneral("layer-RouteSheetLocations-Unit", "routeSheetLocationsSource-Unit", "Icon", "Ubicaciones de unidades", this.generalMapIconSize, true);

      //para ver las areas de asignacion de servicios
      this.mapHelperService.AddLayerCustomizablePolygons( "layer-serviceAssignmentRegions", "serviceAssignmentRegionsSource", 0.3, "Regiones de asignación", "#3410ff", 22, 0);
      this.mapHelperService.AddLayerLine( "layer-line-serviceAssignmentRegions", "serviceAssignmentRegionsSource", "Líneas de regiones", "#1900a7", 3);
      this.mapHelperService.AddLayerCustomizablePolygons( "layer-serviceAssignmentZones", "serviceAssignmentZonesSource", 0.6, "Zonas de asignación", "#3e9be7", 22, 0);
      this.mapHelperService.AddLayerLine( "layer-line-serviceAssignmentZones", "serviceAssignmentZonesSource",  "Líneas de zonas", "#00274b", 3);
      this.mapHelperService.AddLayerCustomizablePolygons( "layer-serviceAssignmentClusters", "serviceAssignmentClustersSource",0.8, "Clusters de asignación", "#b60000", 22, 0);
      this.mapHelperService.AddLayerLine( "layer-line-serviceAssignmentClusters", "serviceAssignmentClustersSource", "Líneas de clusters", "#840000", 3);
      this.mapHelperService.AddLayerIcon("layer-serviceAssignmentFinishedEngineer", "serviceAssignmentFinishedEngineerSource", "engineerAssigned.png", "Ingeniero asignado", 0.1);
      this.mapHelperService.AddLayerIcon("layer-serviceAssignmentFinishedService", "serviceAssignmentFinishedServiceSource", "service.png", "Servicio finalizado", 0.15);
    }
  
  onFocusPin( identifier: any, isRefocus: boolean = false) {
      // this.panelLocationsService.setLoading(true);
        this.panelDetailLocationsService.setVisibilityPopup(true);
        this.panelDetailLocationsService.setLoading(true);
        this.locationsubscription = this.locationsService.getByIdentifier(identifier).subscribe( (data: EstatusJSON) => {
          if (data.isSuccess == true && data.result != null) {

            if(!this.mapRestrictionsService.isCategoryAllowed(data.result.idLocationCategory?.toString())){
              this.notifyService.message("La categoría de la ubicación seleccionada no tiene permitido mostrar su detalle en el mapa.");
              this.panelDetailLocationsService.setVisibilityPopup(false);
              this.panelDetailLocationsService.setLoading(false);
              this.panelLocationsService.setLoading(false);
              this.locationsService.setLoading(false);
              return;
            }

            if(!environment.production) console.log("PIN SELECTED", data.result);
            this.panelDetailLocationsService.UpdateDetailLocation(data.result);
            this.panelLocationsService.setLoading(false);
            this.locationsService.setLoading(false);
            this.geoClustersFrecuencyCatalogService.setRecurrentPlaces(false);
            this.PinSelected = data.result;
  
            if ( this.PinSelected.cordsX != null && this.PinSelected.cordsY != null && this.PinSelected.cordsX != "" && this.PinSelected.cordsY != "" ) {
              this.mapHelperService.FlyToCamera( this.PinSelected.cordsY, this.PinSelected.cordsX, "15");
            }
  
            var coords = "No disponible"
            var x = Number(this.PinSelected.cordsX);
            var y = Number(this.PinSelected.cordsY);
            if (typeof y === 'number'  && typeof x === 'number' && !isNaN(y) && !isNaN(x))
              coords = y.toFixed(4) + "," + x.toFixed(4);

            this.panelDetailLocationsService.setCoords(coords);
            this.locationsubscription.unsubscribe();
          }else{
            Sentry.captureMessage('LocationsSectionService.onFocusPin: datos no disponibles', { level: 'warning', extra: { identifier, response: data } });
            this.notifyService.message("No se encontraron datos relacionados con el activo seleccionado.");
            this.panelDetailLocationsService.setLoading(false);
            this.panelLocationsService.setLoading(false);
            this.locationsService.setLoading(false);
            this.panelDetailLocationsService.setVisibilityPopup(false);
          }
        },
        (error) => {
          this.stopFocusPin();
          this.panelDetailLocationsService.setVisibilityPopup(false);
          this.notifyService.message("No se encontraron datos relacionados con el activo seleccionado.");
        }
      );
    }
  
    stopFocusPin() {
      this.panelDetailLocationsService.setLoading(false);
      this.panelLocationsService.setLoading(false);
      this.locationsService.setLoading(false);
      this.locationsubscription.unsubscribe();
    }

  CreateCategoryLayerEvents(capa: LayerDTO) {
      const defaultCategoryClick = (e) => {
        var obj: any = e.features[0].properties;
        if(!environment.production) console.log("Objeto Clicked", obj);
        var $identifier: string = e.features[0].properties._Id;
        var $locationCategory: number = e.features[0].properties.IdLocationCategory;
        if(!environment.production) console.log("category layer Data", obj, $locationCategory);
        this.panelDetailLocationsService.setCategorySelected($locationCategory);
          setTimeout(() => {
            // this.panelDetailLocationsService.setVisibilityPopup(true);
            this.panelDetailLocationsService.setLoading(true);
          }, 500);
        this.onFocusPin($identifier);
      };
  
      const popUpCategoryClick = (e) => {
        const obj: any = e.features[0].properties;
        if(!environment.production) console.log("Objeto Clicked", obj);
        
        const identifier: string = e.features[0].properties._Id;
        const idLocationCategories: number = e.features[0].properties.IdLocationCategory;
        const description: string = e.features[0].properties.Description;
        const date: string = e.features[0].properties._CreatedIn != null && e.features[0].properties._CreatedIn != undefined ? e.features[0].properties._CreatedIn : "Sin datos de fecha";
        const name: string = e.features[0].properties.Name != null && e.features[0].properties.Name != undefined ? e.features[0].properties.Name : "";
        const img: string = e.features[0].properties.LocationCategoryActiveIcon;
        const images = JSON.parse(this.localStorageService.getUrlMapList());
        const imgUrl = images.find((x) => x.name === img);
  
        var title = description != null && description != "..." ? description : identifier;
      
        // Crea el componente dinámicamente y pone estilo
        const componentRef: ComponentRef<CarouselComponent> = this.carouselViewContainerRef.createComponent(CarouselComponent);
        componentRef.instance.identifier = identifier;
        componentRef.instance.idLocationCategory = idLocationCategories;
        const carouselElement = componentRef.location.nativeElement;
        this.renderer.setStyle(carouselElement, 'display', 'flex');
        this.renderer.setStyle(carouselElement, 'height', '100%');
        this.renderer.setStyle(carouselElement, 'max-height', '120px');
  
        // Contenedor del popup
        const popupContainer = document.createElement('div');
        popupContainer.className = 'popup-container';
        popupContainer.style.position = 'relative';
        popupContainer.style.height = 'auto';
        popupContainer.style.display = 'flex';
        popupContainer.style.flexDirection = 'column';
        popupContainer.style.justifyContent = 'center';
      
        // para crear el carousel
        const carouselContainer = document.createElement('div');
        carouselContainer.style.width = "100%";
        // carouselContainer.style.minHeight = "15px";
        carouselContainer.style.maxHeight = "115px";
        carouselContainer.style.height = "auto";
        carouselContainer.style.overflow = 'hidden'; 
        carouselContainer.style.position = 'relative'; 
        // carouselContainer.style.marginTop = '8px'; 
        carouselContainer.appendChild(carouselElement);
        popupContainer.appendChild(carouselContainer);
      
        // Ttítulo con descripcion y clic
        const titleElement = document.createElement('h3');
        titleElement.innerText = title;
        titleElement.style.margin = '0 0 3px 10px';
        titleElement.style.color = '#3f51b5';
        titleElement.style.overflowX = 'auto';
        titleElement.style.overflowY = 'hidden';
        titleElement.style.maxHeight = '40px';
        titleElement.style.width = '90%';
        titleElement.style.whiteSpace = 'nowrap';
        titleElement.addEventListener('mouseover', () => {
          titleElement.style.color = '#31ab45';
          titleElement.style.textDecoration = 'underline';
          titleElement.style.cursor = 'pointer';
        });
        titleElement.addEventListener('mouseleave', () => {
          titleElement.style.color = '#3f51b5';
          titleElement.style.textDecoration = 'none';
        });
        titleElement.addEventListener('click', () => {
          this.locationsService.setLoading(true);
          this.onFocusPin(identifier);
        });
        popupContainer.appendChild(titleElement);
      
        // descripción flex padre
        const descriptionElement = document.createElement('div');
        descriptionElement.style.height = '50px';
        descriptionElement.style.margin = '0';
        descriptionElement.style.display = 'flex';
        descriptionElement.style.flexDirection = 'row';
  
        //imagen a la izquierda
        const descriptionImageElement = document.createElement('img');
        descriptionImageElement.style.width = '25%';
        descriptionImageElement.style.objectFit = 'contain'; 
        descriptionImageElement.style.marginRight = '8px'; 
        // descriptionImageElement.style.borderRadius = '4px'; 
        descriptionImageElement.src = imgUrl?.url || ''; 
        descriptionElement.appendChild(descriptionImageElement);
  
        //flex con datos a la derecha
        const descriptionDataElement = document.createElement('div');
        descriptionDataElement.style.margin = '0';
        descriptionDataElement.style.display = 'flex';
        descriptionDataElement.style.flexDirection = 'column';
        descriptionElement.appendChild(descriptionDataElement);
  
        //titulo en los datos de la derecha
        const descriptionDataTitleElement = document.createElement('p');
        descriptionDataTitleElement.style.maxHeight = '25px';
        descriptionDataTitleElement.style.overflowX = 'auto';
        descriptionDataTitleElement.style.overflowY = 'hidden';
        descriptionDataTitleElement.style.margin = '0';
        descriptionDataTitleElement.style.whiteSpace = 'nowrap';
        descriptionDataTitleElement.style.fontWeight = 'bold';
        descriptionDataTitleElement.innerText = identifier;
        descriptionDataElement.appendChild(descriptionDataTitleElement);
  
        //fecha en los datos de la derecha
        const descriptionDataDateElement = document.createElement('p');
        descriptionDataDateElement.style.maxHeight = '25px';
        descriptionDataDateElement.style.overflowX = 'hidden';
        descriptionDataDateElement.style.overflowY = 'hidden';
        descriptionDataDateElement.style.margin = '0';
        descriptionDataDateElement.style.whiteSpace = 'nowrap';
        descriptionDataDateElement.innerText = date;
        descriptionDataElement.appendChild(descriptionDataDateElement);
  
        //nombre en los datos de la derecha
        const descriptionDataNameElement = document.createElement('p');
        descriptionDataNameElement.style.maxHeight = '25px';
        descriptionDataNameElement.style.overflowX = 'hidden';
        descriptionDataNameElement.style.overflowY = 'hidden';
        descriptionDataNameElement.style.margin = '0';
        descriptionDataNameElement.style.whiteSpace = 'nowrap';
        descriptionDataNameElement.style.fontWeight = 'bold';
        descriptionDataNameElement.innerText = name;
        descriptionDataElement.appendChild(descriptionDataNameElement);
  
        popupContainer.appendChild(descriptionElement);
      
        // Crear y mostrar el popup
        new mapboxgl.Popup(
          {
            closeButton: true,
            className: 'images-popup'
          }
        )
          .setLngLat(e.lngLat)
          .setDOMContent(popupContainer) // Usar el contenedor con el contenido dinámico
          .addTo(this.mapHelperService._map);
      };
  
      //Se puede hacer dinamico TODO
      if(capa.name.includes("ervicio")){
        this.mapHelperService._map.off("click", capa.name + "-layer", popUpCategoryClick);
        this.mapHelperService._map.on("click", capa.name + "-layer", popUpCategoryClick);
      }else{
        this.mapHelperService._map.off("click", capa.name + "-layer", defaultCategoryClick);
        this.mapHelperService._map.on("click", capa.name + "-layer", defaultCategoryClick);
      }
  
      var hoveredMarker = null;
      var popup = new mapboxgl.Popup({});
  
      var categoryMouseEnter = (e) => {
        if (hoveredMarker && hoveredMarker._Id === e.features[0].properties._Id) {
          return;
        }
        const coordinates = (e.features[0].geometry as any).coordinates.slice();
  
        // Obtener ID del marcador
        const marker = e.features[0].properties;
        if(!environment.production) console.log("markerId", marker, hoveredMarker, e.features[0]);
  
        // Almacenar referencia al marcador
        hoveredMarker = marker;
  
        const icon = e.features[0].properties.LocationCategoryIcon ? e.features[0].properties.LocationCategoryIcon : capa.icon;
        const activeIcon = e.features[0].properties.LocationCategoryActiveIcon ? e.features[0].properties.LocationCategoryActiveIcon : capa.icon.replace(".png", "A.png");
        // Cambiar icono del marcador
        this.mapHelperService._map.setLayoutProperty(capa.name + "-layer", "icon-image", [
          "match",
          ["get", "_Id"],
          hoveredMarker._Id,
          activeIcon,
          // capa.icon.replace(".png", "")
          ["coalesce", ["get", "LocationCategoryIcon"], capa.icon]
        ]);
  
        // cambia el color del nombre
        this.mapHelperService._map.setPaintProperty(capa.name + "text-layer", "text-color", [
          "match",
          ["get", "_Id"],
          hoveredMarker._Id,
          "#0F010F",
          "#530aa8",
        ]);
  
        // Mostrar popup y lo guarda en la cariable para despues cerrarlo
        // popup = new mapboxgl.Popup({ offset: [0, -15] })
        //     .setLngLat(coordinates)
        //     .setHTML(`<h3>${nombre}</h3>`)
        //     .addTo(this._map);
      }
  
      var categoryMouseLeave = () => {
        // Restaurar icono y texto del punto solo si hay un punto bajo el mouse
        if (hoveredMarker) {
          const icon = hoveredMarker && hoveredMarker.LocationCategoryIcon ? hoveredMarker.LocationCategoryIcon : capa.icon;
          this.mapHelperService._map.setLayoutProperty(
            capa.name + "-layer",
            "icon-image",
            ["coalesce", ["get", "LocationCategoryIcon"], icon]
          );
          this.mapHelperService._map.setPaintProperty(
            capa.name + "text-layer",
            "text-color",
            "#530aa8"
          );
          hoveredMarker = null;
        }
  
        // Cerrar popup si está abierto
        if (popup) {
          popup.remove();
          popup = null;
        }
      }
  
      // Evento mouseenter
      this.mapHelperService._map.off("mouseenter", capa.name + "-layer", categoryMouseEnter);
      this.mapHelperService._map.off("mouseenter", capa.name + "text-layer", categoryMouseEnter);
      this.mapHelperService._map.on("mouseenter", capa.name + "-layer", categoryMouseEnter);
      this.mapHelperService._map.on("mouseenter", capa.name + "text-layer", categoryMouseEnter);

      // Evento mouseleave
      this.mapHelperService._map.off("mouseleave", capa.name + "-layer", categoryMouseLeave);
      this.mapHelperService._map.off("mouseleave", capa.name + "text-layer", categoryMouseLeave);
      this.mapHelperService._map.on("mouseleave", capa.name + "-layer", categoryMouseLeave);
      this.mapHelperService._map.on("mouseleave", capa.name + "text-layer", categoryMouseLeave);
    }

  public loadStreetView(coordX, coordY) {
    const url =
      "http://maps.google.com/maps?q=&layer=c&cbll=" +
      coordY +
      "," +
      coordX +
      "&cbp=12,0,0,0,0";
    window.open(url, "_blank");

    // pra i frame de streetview
    // const url = 'https://www.google.com/maps/embed?pb=!4v1618458822483!6m8!1m7!1s!2m2!1d'+coordY+'!2d'+coordX+'!3f100!4f0!5f0.7820865974627469';
    // this.streetViewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    // this.isStreetViewUrlReady = true;
    // document.getElementById('streetView').style.zIndex = '6';

    // // Verificar si el botón ya existe para evitar duplicados
    // if (!document.getElementById('closeViewerBtn')) {
    //   const closeButton = document.createElement('button');
    //   closeButton.id = 'closeViewerBtn';
    //   closeButton.innerText = 'X';
    //   closeButton.style.position = 'absolute';
    //   closeButton.style.top = '10px';
    //   closeButton.style.right = '10px';
    //   closeButton.style.zIndex = '1000';
    //   closeButton.style.padding = '5px 10px';
    //   closeButton.style.backgroundColor = '#f00';
    //   closeButton.style.color = '#fff';
    //   closeButton.style.border = 'none';
    //   closeButton.style.cursor = 'pointer';

    //   document.getElementById('streetView').appendChild(closeButton);

    //   // evento para hover del botón
    //   closeButton.addEventListener('mouseover', () => {
    //     closeButton.style.backgroundColor = 'rgb(193 0 0)';
    //   });
    //   closeButton.addEventListener('mouseleave', () => {
    //     closeButton.style.backgroundColor = '#f00';
    //   });

    //   // evento para cerrar el Viewer
    //   closeButton.addEventListener('click', () => {
    //     document.getElementById('streetView').style.zIndex = '-1';
    //     closeButton.remove();
    //     this.isStreetViewUrlReady = false;
    //   });
    // }
  }


  addViewAsLoadedToStorage(){
    const mapLoadedViewsEnc = this.localStorageService.getMapLoadedViews();
    if (mapLoadedViewsEnc == null) {
        return;
    }
    
    const decrypted = this.encriptionService.DecryptData(mapLoadedViewsEnc);
    if (decrypted == null) {
      this.localStorageService.setMapLoadedViews(this.encriptionService.EncryptData(JSON.stringify([MAP_MODULE_NAMES.Locations])) );
      this.sessionService.loadedMapComponents.next([MAP_MODULE_NAMES.Locations]);
      return;
    }
    
    var arr: any[] = [];
    try {
        const parsed = JSON.parse(decrypted);
        arr = parsed;
    } catch (e) {
        arr = [];
    }
    
    const key = MAP_MODULE_NAMES.Locations;
    if (!arr.includes(key)) {
      arr.push(key);
      this.localStorageService.setMapLoadedViews(this.encriptionService.EncryptData(JSON.stringify(arr)) );
      this.sessionService.loadedMapComponents.next(arr);
    }
  }
}
